module.exports = __webpack_public_path__ + "static/img/bj1.4e8a68b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bj1.gif
// module id = fCNy
// module chunks = 89